import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import { useLang } from '@/i18n';
import { redirectTo404 } from '@/utils';
import { GetServerSidePropsContext } from 'next';
import { useRouter } from 'next/router';
import { whiteList, theme } from '@elem/compPage/StreamNL/config';
import OverView from '@elem/compPage/StreamNL';

const Page: React.FC = ({ SEO }: any) => {
    const { t } = useLang('stream');
    const { locale = '' } = useRouter();
    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA list={whiteList} locale={locale} pathname={'ecoflow-stream-plug-in-thuisbatterij'} />
            <PageLayout isNoFixed theme={theme}>
                <OverView />
            </PageLayout>
        </>
    );
};
export default Page;

export async function getServerSideProps({ locale = 'us' }: GetServerSidePropsContext) {
    if (!whiteList.includes(locale)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
